import { TableHead } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS } from 'utils/constants/dashboard';

type EventDrillDownTableHeaderProps = {
  handleSort: (column: string) => void;
};

const EventDrillDownTableHeader = ({
  handleSort,
}: EventDrillDownTableHeaderProps) => {
  const headCells = [
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.EVENT_TITLE,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.EVENT_TITLE'
      ),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.EVENT_TYPE,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.EVENT_TYPE'
      ),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.START,
      content: intl.get('DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.START'),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.END,
      content: intl.get('DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.END'),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.FACILITATORS,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.FACILITATORS'
      ),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.RECURRING_EVENT,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.RECURRING_EVENT'
      ),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.NUMBER_OF_DAYS,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.NUMBER_OF_DAYS'
      ),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.DAILY_DURATION,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.DAILY_DURATION'
      ),
    },
    {
      columnName: EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TOTAL_DURATION,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.TOTAL_DURATION'
      ),
    },
    {
      columnName:
        EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.NUMBER_OF_DAYS_IN_RANGE,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.NUMBER_OF_DAYS_IN_RANGE'
      ),
    },
    {
      columnName:
        EVENT_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TOTAL_DURATION_IN_RANGE,
      content: intl.get(
        'DASHBOARDS_EVENT_DRILLDOWN_PAGE.TABLE.HEAD.TOTAL_DURATION_IN_RANGE'
      ),
    },
  ];

  return (
    <TableHead stickyHeader handleSort={handleSort} headCells={headCells} />
  );
};

export default EventDrillDownTableHeader;
